import './index.css';
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
document.title = "Najah | App Showcase";
const link = document.createElement("link");
link.rel = "icon";
link.href = "https://i.imgur.com/worwanV.png";
document.head.appendChild(link);
render(<App data-id="element-216" />, document.getElementById("root"));